import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { useMediaQuery } from '@mui/material';

import { MenuData } from 'app/constants/types';
import { getTheme } from 'app/components/ThemeProvider/theme';

interface Props {
  children: ReactNode;
  setOpen: (st: boolean) => void;
  open: boolean;
  hide?: boolean;
  menu?: MenuData[];
}
const DrawerCustom = (props: Props) => {
  const { children, open, setOpen, hide, menu } = props;

  const location = useLocation();
  const theme = getTheme();
  const mediumScreen = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    if (!mediumScreen) return;

    setOpen(false);
  }, [location]);

  return (
    <>
      {hide ? (
        <SwipeableDrawer
          sx={{
            '& .MuiDrawer-paper': { width: '341px', maxWidth: '100%' },
            '& .MuiBackdrop-root': { backgroundColor: 'rgba(0, 0, 0, 0.15)' },
          }}
          anchor={'left'}
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
        >
          {children}
        </SwipeableDrawer>
      ) : (
        children
      )}
    </>
  );
};

export default DrawerCustom;
